import Card from '@rio-cloud/rio-uikit/Card';
import Select, {SelectOption} from "@rio-cloud/rio-uikit/Select";
import {useState} from 'react';

import {
    DropdownContainer,
    StyledTable
} from "@/components/molecule/CardDropdown/CardDropdown.styles";

type CardDropdownProps = {
    children: Array<Record<string, unknown>>;
};

type RowData = {
    header: string;
    value: unknown;
};

type Option = {
    id: string;
    label: string;
    selected: boolean;
};

const CardDropdown = ({ children}: CardDropdownProps) => {
  const [selectedCard, setSelectedCard] = useState(0);

    const handleChange = (item?: SelectOption) => {
        setSelectedCard(item ? Number(item.id) : 0);
    };

  const getRowData = (card: Record<string, unknown>): RowData[] =>
      Object.entries(card).map(([key, value]) => ({
          header: key,
          value,
      }));

  const childrenArray = children ?? [];

  const options: Option[] = childrenArray.map((card, index) => ({
    id: index.toString(),
    label: String(getRowData(card)[0]?.value ?? 'Card'),
    selected: index === 0,
  }));

    return (
        <div>


            <DropdownContainer>
                {options.length > 0 && <Select options={options} onChange={item => handleChange(item)}/>}
            </DropdownContainer>
            <Card>
                <StyledTable className="table table-head-filled table-layout-fixed">
                    <tbody>
                    {childrenArray?.length > 0 &&
                        getRowData(childrenArray[selectedCard]).map((row, rowIndex) => (

                            <tr key={rowIndex} className="table-card-placeholder">
                                <td className={rowIndex === 0 ? 'border-t-0' : ''}>{row.header}</td>
                                <td className={rowIndex === 0 ? 'border-t-0' : ''}>{String(row.value)}</td>
                            </tr>
                        ))}
                    </tbody>
                </StyledTable>
            </Card>
        </div>
    );
};

export default CardDropdown;
